import { css as e } from "@emotion/react";
import { t as l } from "./breakpoints-DvaoDEis.mjs";
function p(n, i) {
  return /* @__PURE__ */ e("position:relative;display:-webkit-box;max-block-size:calc(", n, " * ", i, ");line-height:", i, ";text-overflow:ellipsis;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:", n, ";", "");
}
var t = {
  name: "1q3ym6v",
  styles: "inline-size:100%"
};
function m(n = !1, i = 28, r = 12, a = 1560) {
  return /* @__PURE__ */ e("margin-block:0;margin-inline:auto;box-sizing:border-box;", n && t, " ", a && /* @__PURE__ */ e("max-inline-size:", a, "px;", ""), " ", r && /* @__PURE__ */ e("padding-inline:", r, "px;", ""), " ", i && /* @__PURE__ */ e(l.breakpoints.up("tablet"), "{padding-inline:", i, "px;}", ""), " ", i && a && /* @__PURE__ */ e("@media (min-width: ", a + i * 2, "px){padding:0;}", ""), ";", "");
}
export {
  m as a,
  p as s
};
//# sourceMappingURL=grids-XsImbhoi.mjs.map
